import styled from 'styled-components'
import { TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

export const StyledTextField = styled(TextField)`
  && {
    background: ${(props) => props.theme.colors.darkLight};
    max-width: 277px;

    @media (max-width: 800px) {
      min-width: calc(100% - 65px);
    }

    & .MuiOutlinedInput-root {
      border-radius: 4px;
      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: ${(props) => props.theme.colors.graySemiDark};
      }
    }

    & .MuiInputLabel-root {
      font-size: 20px;
      color: ${(props) => props.theme.colors.gray};
      top: -3.5px;

      &.Mui-focused {
        font-size: 20px;
        color: ${(props) => props.theme.colors.lightRed} !important;
      }

      &:not(.Mui-focused):not(.MuiInputLabel-shrink) {
        top: -9.5px;
      }
    }

    & .MuiOutlinedInput-notchedOutline {
      border: 2px solid ${(props) => props.theme.colors.gray};
    }

    & .Mui-focused .MuiOutlinedInput-notchedOutline {
      border: 2px solid ${(props) => props.theme.colors.lightRed} !important;
    }

    & input {
      padding: 6.25px 16px 7px 16px;
      font-size: 20px;
      color: ${(props) => props.theme.colors.gray};
    }

    & fieldset legend {
      font-size: 14px;
    }
  }
`

export const StyledIconSearch = styled(SearchIcon)`
  color: ${(props) => props.theme.colors.gray};
  font-size: 24px;
`
